// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".desc[data-v-68b9c1b8] {\n  font-size: small;\n  color: #8c8c8c;\n}\n.org-item[data-v-68b9c1b8] {\n  margin: 5px;\n}", ""]);
// Exports
module.exports = exports;
